// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b6pt","title":"styles_title__3uvYO"};